/* eslint-disable */
export default {
  'tr-TR': {
    common: {
      NAME_HOLDER: "İsim *",
      LAST_NAME_HOLDER: "Soyisim *",
      EMAIL_HOLDER: "E-posta *",
      PASS_HOLDER: "Şifre oluştur *",
      REPEAT_PASS_HOLDER: "Şifreyi tekrarla *",
      BUTTON_EMAIL_SIGN_UP: "E-posta adresiyle kaydol",

      TERMS_AND_CONDITIONS: "Terms and Conditions",
      PRIVACY_POLICY: "Privacy Policy",

      NEWSLETTER_CONSENT: "Time Out'tan en son haberlere, etkinliklere, tekliflere ve iş ortaklarının tanıtımlarına dair e-postalar almayı kabul ediyorum.",
      TERM_OF_USE: "I have read and accept the {{terms_and_conditions}} and {{privacy_policy}} of Time Out",
      TERM_OF_USE_WITH_NEWSLETTERS: "Time Out kullanım koşullarını ve bültenine üye olmayı kabul ediyorum",

      HEADER_TITLE: "Time Out Hesabı Oluştur",
      JOIN_FB: "Facebook ile üye ol",
      JOIN_TW: "Twitter ile üye ol",
      JOIN_GG: "Google ile üye ol",
      JOIN_EM: "E-posta ile üye ol",
      ALREADY_HAVE: "Zaten bir Time Out hesabınız var mı?",
      CREATE_ACCOUNT_LOG_IN: "Giriş yap",

      SIGN_IN_TITLE: "Giriş yap",
      SIGN_IN_FB: "Facebook ile giriş yap",
      SIGN_IN_TW: "Twitter ile giriş yap",
      SIGN_IN_GG: "Google ile giriş yap",
      SIGN_IN_EM: "E-posta ile giriş yap",
      YOUR_EMAIL: "E-posta adresiniz",
      YOUR_PASSWORD: "Şifreniz",
      REMEMBER: "Beni hatırla",
      FORGOT: "Unuttunuz mu?",
      HAVE_ACCOUNT_YET: "Time Out hesabınız yok mu?",
      JOIN_HERE: "Buradan üye olun",
      ALMOST_THERE: "Neredeyse",

      FORGOT_HEADER: "Şifrenizi mi unuttunuz?",
      FORGOT_SUBTITLE: "Sorun yok. Sadece e-posta adresinizi girin - size şifrenizi sıfırlamak için bir bağlantı gönderelim",
      SEND_LINK: "Bağlantı gönder",

      RECEIVE_EMAIL: "Teşekkürler, çok yakında bir e-posta alacaksınız",
      MANAGE_ACCOUNT: "Hesabınızı yönetin",
      EDIT_DETAILS_HERE: "Hesap detaylarınıza buradan göz atabilirsiniz",
      FIRST_NAME: "İsim",
      LAST_NAME: "Soyisim",
      SCREEN_NAME: "Profil İsmi",
      EMAIL: "E-posta",
      ACCOUNT_DETAILS: "Hesap detayları",
      PASSWORD: "Şifre",
      SAVE_CHANGES: "DEĞİŞİKLİKLERİ KAYDET",
      UPLOAD_PIC: "Yeni profil resmi yükle",
      CHOOSE_PHOTO: "Cihazınızdan bir fotoğraf seçin. Maximum büyüklük 2MB olmalıdır.",
      CLOSE_ACCOUNT: "Hesabımı kapat",
      PASSWORD_BELOW: "Aşağıdan şifrenizi değiştirebilirsiniz",
      CURRENT_PASSWORD: "Şu andaki şifreniz",
      NEW_PASSWORD: "Yeni şifreniz",
      REPEAT_PASSWORD: "Yeni şifrenizi tekrar girin",

      OOPS: "Hay aksi",
      ERROR_404_OCCURED: "bir hata oluştu",
      ERROR_404_INFO: "Bu sayfayı taşıdık ya da artık bulunmuyor.",
      ERROR_500_TITLE: "Sunucu bir ... döndü ",
      SMTH_BROKEN: "Bir sorun var",
      INTERNAL_RED: "500 Sunucu Hatası",
      LET_KNOW_RED: "Lütfen bu hata oluştuğunda ne yapıyor olduğunuzu anlatın. En kısa zamanda çözeceğiz. Verdiğimiz herhangi bir rahatsızlıktan ötürü özür dileriz.",
      ERROR_500_INFO: "what you were doing when this error occurred. We will fix it as soon as possible. Sorry for any inconvenience caused.",

      EMAIL_ERROR: "Lütfen geçerli bir e-posta adresi giriniz",
      PASSWORD_ERROR: "Lütfen bir şifre giriniz",
      FIRST_NAME_ERROR: "Lütfen adınızı giriniz",
      LAST_NAME_ERROR: "Lütfen adınızı giriniz",
      TERM_OF_USE_ERROR: "Kullanım şartlarımızı kabul etmeniz gerekir",
      SIGN_IN_VALIDATION_ERROR: "Hatalı e-posta ya da şifre - lütfen tekrar deneyiniz",
      ACCOUNT_PASSWORDS_VALIDATION: "Şifreler uyuşmuyor",
      WAS_IT: "Yoksa hata bizde mi?",
      DELETE_ACCOUNT_TEXT: "Hesabınızı silmek istediğiniz için üzgünüz. Gitmenize neden olacak bir şey varsa",
      DELETE_ACCOUNT: "Hesabı Sil",
      CANCEL: "İptal",

      UPDATE_PASSWORD: "Şifrenizi güncelleyin",
      PASSWORD_UPDATE_SUCCESS: "Şifreniz güncellendi",
      ERROR_PASSWORD_LENGTH: "Şifre en az 6 karakter içermelidir",

      ERROR_MISSING_SITE_PARAMETER: "Gerekli uygulama parametresi eksik: site",
      ERROR_ALREADY_REGISTERED: "Zaten e-posta kayıt kullanarak kayıt oldunuz. Lütfen {{email}} kullanarak giriş yapın",
    },
    'tr-istanbul': {
      TERM_OF_USE: '<a class="xs-text-red cursor-pointer" href="https://www.timeout.com/istanbul/tr/kullanim-kosullari" target="_blank">' +
      "Time Out kullanım koşullarını ve bültenine üye olmayı kabul ediyorum</a>",
    }
  }
}



// WEBPACK FOOTER //
// ./translations/tr-TR.js